import React from "react";
import Seo from "@/components/Seo";
import Hero from "@/components/Hero";
import { TrustBar, Testimonials, FAQSection } from "@/components/Social";
import { WhyWater, WhyMagic, Highlights, CruiseDates, Occasions, Departure, KeywordIntro } from "@/components/ContentSections";
import TicketBooking, { TopBooking } from "@/components/TicketBooking";
import { IMAGES } from "@/data";

const Home = () => (
  <main>
    <Seo
      title="Vivid Cruises Sydney | Vivid Sydney Harbour Cruise 2027"
      description="Vivid Cruises Sydney is one of Sydney's premier Vivid Sydney Harbour cruises. Front row views of the Opera House, Harbour Bridge & Circular Quay light installations. Adults $49, kids $35. Book online."
      canonical="https://vividcruisessydney.com.au/"
      image={IMAGES.hero.src}
    />
    <Hero />
    <TrustBar />
    <TopBooking />
    <KeywordIntro />
    <WhyWater />
    <WhyMagic />
    <Highlights />
    <CruiseDates />
    <Occasions />
    <TicketBooking />
    <Testimonials />
    <Departure />
    <FAQSection />
  </main>
);

export default Home;
